/** total_unread API のレスポンス */
export type TotalUnreadResponse = { unread_num: number };

export type Conversation = {
  id: string;
  partnerId: string;
  partnerName: string;
  partnerAvatar: string | null;
  lastMessage: string | null;
  lastMsgType?: string;
  lastMessageAt: string | null;
  unreadCount: number;
  isOwn: boolean;
  age: number | null;
  region: number | null;
  isOnline: boolean;
  lastLoginTime: string | null;
  hasMedia: boolean;
  /** ビデオ通話を受け付けているか */
  videoCallWaiting: boolean;
  /** 音声通話を受け付けているか */
  voiceCallWaiting: boolean;
  /** Lovense 対応か */
  hasLovense: boolean;
};

/** list_conversation APIレスポンスの生型（snake_case） */
export type ConversationApiItem = {
  frd_id: string;
  frd_name: string;
  ava_id: string | null;
  last_msg: string | null;
  msg_type?: string;
  one_before_msg_type?: string | null;
  sent_time: string;
  unread_num: number;
  is_own: boolean;
  age?: number;
  region?: number;
  is_online?: boolean;
  last_login_time?: string;
  lastLoginTime?: string;
  /** ビデオ通話受付フラグ */
  video_call_waiting?: boolean;
  /** 音声通話受付フラグ */
  voice_call_waiting?: boolean;
  /** Lovense 対応フラグ */
  has_lovense?: boolean;
};

export type ConversationListResponse = ConversationApiItem[];

export const ALL_CHAT_TABS = ["all", "active", "bookmark"] as const;
export type ChatTab = (typeof ALL_CHAT_TABS)[number];

// Chat Room types

export type MessageKind =
  | "text"
  | "call_log"
  | "absence_call"
  | "call_request"
  | "image"
  | "video"
  | "audio"
  | "unpurchased_image"
  | "unpurchased_video"
  | "unpurchased_audio"
  | "sticker"
  | "like";

export type SendStatus = "sent" | "sending" | "error";

/** APIレスポンスそのまま（snake_case） */
export type ChatMessageData = {
  msg_id: string;
  content: string;
  is_own: boolean;
  msg_type: string;
  time_stamp: string;
  read_time: string | null;
};

/** UIで使用するドメインモデル */
export type Message = {
  id: string;
  content: string;
  /** 翻訳表示用の元テキスト（T13で使用） */
  originalText: string | null;
  isOwn: boolean;
  /** 自分が送信したメッセージを相手が既読にしたか（isOwn: true のみ有効） */
  isRead?: boolean;
  timestamp: Date;
  sendStatus: SendStatus;
  kind: MessageKind;
  /** 画像/動画/音声のファイルID */
  fileId?: string;
  /** 動画/音声の長さ（秒） */
  mediaDuration?: number;
  /** 通話終了の通話時間（"HH:MM:SS" 形式、call_log の場合のみ） */
  callDuration?: string;
  /** 通話種別（absence_call の場合のみ） */
  callType?: "video" | "voice";
};

export type GetChatHistoryRequest = {
  userId: string;
  frdId: string;
  timeStamp: string;
  take: number;
};

/** get_chat_history のレスポンス（apiClient が json.data を返すため配列そのもの） */
export type GetChatHistoryResponse = ChatMessageData[];

export type SendMessageRequest = {
  userId: string;
  rcvId: string;
  content: string;
  isFree: boolean;
};

export type SendMessageResponse = {
  myPoint: number;
};

export type SendImageRequest = {
  userId: string;
  partnerId: string;
  fileId: string;
};

export type SendVideoRequest = {
  userId: string;
  partnerId: string;
  fileId: string;
  duration: number;
};

/** lst_pbimg レスポンスの1件（profile feature の PublicImage と同型） */
export type PartnerPublicImage = {
  img_id: string;
  buzz_id: string;
};

/** get_opened_image / get_opened_video の生レスポンス（Jambo API は snake_case） */
export type OpenedMediaApiItem = {
  file_id: string;
};

/** 開封済みメディア（camelCase に変換後のドメイン型） */
export type OpenedMediaItem = {
  fileId: string;
};
